import React from 'react'
import Banner from "../components/Careers-section/salesNoida/Banner"
import DetailSalesNoida from "../components/Careers-section/salesNoida/DetailSalesNoida"
import ScrollToTop from '../components/Home-section/GotoTop/ScrollToTop'

function SalesNoida() {
  return (
    <div>
        <ScrollToTop />
        <Banner />
        <DetailSalesNoida />
    </div>
  )
}

export default SalesNoida